export default __webpack_public_path__ + "static/media/UnileverLogo.ec3e6dfc.svg";